// UserForm.js
import React, { useState } from "react";
import {
  EuiForm,
  EuiFormRow,
  EuiFieldText,
  EuiFieldPassword,
  EuiSelect,
  EuiFieldNumber,
  EuiTextArea,
  EuiButton,
  EuiText,
} from "@elastic/eui";
import useFetch from "react-fetch-hook";
import { PostOptions } from "../utils/RequestUtils";
import { getApiUrl } from "../utils/api";

const CourseAddForm = ({ onSuccess }) => {
  const [form, setForm] = useState({
    course_name: "",
    course_number: "",
    course_description: "",
    image_url: "https://picsum.photos/400/200",
    mode: "step-by-step",
    default_assistance_level: 1,
  });

  const [isLoading, setisLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage(null);
    setHasError(false);
    setisLoading(true);
    fetch(getApiUrl("/api/course/add"), PostOptions(form))
      .then((response) => {
        return response.json().then((text) => {
          if (!response.ok) {
            setErrorMessage(text.message);
            setHasError(true);
            alert(text.message);
            throw new Error(text.message);
          }
          return text;
        });
      })
      .then((data) => {
        setisLoading(false);
        onSuccess();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setisLoading(false);
      });
  };

  return (
    <EuiForm
      component="form"
      onSubmit={handleSubmit}
      isInvalid={hasError}
      error={errorMessage}
    >
      <EuiFormRow label="CourseName">
        <EuiFieldText
          name="course_name"
          value={form.course_name}
          onChange={handleChange}
        />
      </EuiFormRow>

      <EuiFormRow label="Course Number">
        <EuiFieldText
          name="course_number"
          value={form.course_number}
          onChange={handleChange}
        />
      </EuiFormRow>

      <EuiFormRow label="Course Description">
        <EuiTextArea
          fullWidth
          value={form.course_description}
          onChange={handleChange}
          name="course_description"
        />
      </EuiFormRow>

      <EuiFormRow label="Image URL">
        <EuiFieldText
          name="image_url"
          value={form.image_url}
          onChange={handleChange}
        />
      </EuiFormRow>

      <EuiFormRow label="Mode">
        <EuiSelect
          name="mode"
          options={[
            { value: "step-by-step", text: "Step-by-step" },
            { value: "concise", text: "Concise" },
            { value: "both", text: "Both" },
          ]}
          value={form.mode}
          onChange={handleChange}
        />
      </EuiFormRow>

      <EuiFormRow label="Default AI Assistance Level">
        <EuiSelect
          name="default_assistance_level"
          options={[
            { value: 1, text: "Level 1 - Idea Spark (no code)" },
            { value: 2, text: "Level 2 - Code Check (review only)" },
            { value: 3, text: "Level 3 - Debug Helper (trace errors)" },
            { value: 4, text: "Level 4 - Co-Builder (draft snippets)" },
            { value: 5, text: "Level 5 - AI Only (full solutions)" },
          ]}
          value={form.default_assistance_level}
          onChange={(e) => setForm({ ...form, default_assistance_level: parseInt(e.target.value, 10) })}
        />
      </EuiFormRow>

      <EuiButton type="submit" fill isLoading={isLoading}>
        Create
      </EuiButton>
    </EuiForm>
  );
};

export default CourseAddForm;
